module.exports = __webpack_public_path__ + "static/media/project_2.7b616b9a.webp";